import { MakeCall } from './createMakeCall';
import { User } from './types/User';

const impersonateUser =
  (makeCall: MakeCall) =>
  (userId: number, isIdentityPlatform = false) => {
    let url = `/api/v2/user/${userId}/impersonate`;

    if (isIdentityPlatform) {
      url += '?isIdentityPlatform=true';
    }

    return makeCall<User>('PUT', url);
  };

export { impersonateUser };
